import React from 'react';
import {
  Drawer,
  DrawerContent,
  Box,
  CloseButton,
  Flex,
  VStack,
  Text as TextComponent,
} from '@chakra-ui/react';
import { userSelector } from 'api/slices/userSlice';
import { NavLinkItems } from './navigator/Navigator';
import { useAppSelector } from 'store';

interface LeftDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

export const LeftDrawer = ({
  isOpen,
  onClose,
}: LeftDrawerProps): JSX.Element => {
  const { user } = useAppSelector(userSelector);
  return (
    <Drawer
      autoFocus={false}
      isOpen={isOpen}
      placement="left"
      onClose={onClose}
      returnFocusOnClose={false}
      onOverlayClick={onClose}
      size="full"
    >
      <DrawerContent>
        <Box
          transition="3s ease"
          bg="white"
          w="100%"
          pos="fixed"
          h="full"
          p="8"
        >
          {user && (
            <Flex
              h="56px"
              alignItems="center"
              mb="3"
              justifyContent="space-between"
            >
              <VStack alignItems="flex-start" spacing="0.5">
                <TextComponent>{user.name}</TextComponent>
              </VStack>
              <CloseButton
                display={{ base: 'flex', md: 'none' }}
                onClick={onClose}
                size="lg"
                color="blue.500"
                _hover={{ bg: 'transparent' }}
                _active={{ bg: 'transparent' }}
              />
            </Flex>
          )}

          <NavLinkItems isMobile={true} onClose={onClose} />
        </Box>
      </DrawerContent>
    </Drawer>
  );
};
